import axios from 'axios';

const state = {
  data: [],
};

const mutations = {
  data(state, value) {
    state.data = value;
  },
};

const actions = {
  get({ commit }, body) {
    return new Promise((resolve, reject) => {
      axios.post('metrics/calls', body)
        .then(({ data }) => {
          commit('data', data);
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
};

const getters = {
  data: state => state.data,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
